export default (description, title) => {
  return {
    'event': 'select_promotion',
    'ecommerce': {
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillaries',
      'items': [{
        'item_id': 'NA',
        'item_name': description,
        'creative_name': title,
        'creative_slot': 'NA',
        'discount': 0,
        'price': 0,
      }],
    },
  };
};
